module.exports = __webpack_public_path__ + "img/948.d4b01057.gif";